import React from 'react';
import { Calculator } from 'lucide-react';
import BrainBoard from '../components/BrainBoard';

// The board itself lives in components/BrainBoard.js, shared with the Procurement
// Brain. This file is only the words and the people. Owners must match the list in
// netlify/functions/lib/accounting-brain-db.js — keep the two in step.
const CONFIG = {
  prefix: 'acct',
  section: 'accounting',
  sectionLabel: 'Accounting',
  title: 'Accounting Brain',
  icon: Calculator,
  briefFn: 'accounting-brief',
  chatGuidance: 'There are four QuickBooks companies here with heavy intercompany rent and loans between them, so always ask which company a number belongs to before answering. Mercedes runs accounting day to day. The outside accountant is Cathy at TRCPA, and she is who an accounting judgement goes to. Tommy is local IT and has nothing to do with the books, so never route an accounting question to him. 2025 is closed and locked and has gone to Cathy for filing, so never suggest editing a 2025 figure: an error found there gets flagged to Mercedes and Cathy, not corrected. Cash flow rather than P&L is the lens here, because loan principal is real cash out that never shows on a P&L.',
  owners: ['Mercedes', 'Greg', 'Claude', 'Tommy', 'Matt Jr', 'CPA'],
  counterOwners: ['Mercedes', 'Greg', 'Claude'],
  ownerRank: ['Mercedes', 'Greg', 'Tommy', 'Matt Jr', 'CPA', 'Claude'],
  blurb: "The roadmap for getting accounting onto its own feet, what we have learned along the way, and what is on each person's plate. Mercedes gets this as a brief every weekday morning.",
  docsEmpty: 'No documents stored yet. Working documents (the plan, handoffs, the month-end procedure) get added here so they are readable without hunting through OneDrive.',
};

export default function AccountingBrain() {
  return <BrainBoard config={CONFIG} />;
}
